import React from 'react';
import ReactVimeoOriginal from '@u-wave/react-vimeo';
import useIsBrowser from 'hooks/useIsBrowser';
import { ErrorBoundary } from '@sentry/react';

// There is a known intermittent error in the react-vimeo package (https://github.com/u-wave/react-vimeo/issues/244)
// The root cause of this error appears to be within the Vimeo player itself (https://github.com/vimeo/player.js/issues/688)
// Until the root cause is fixed in the Vimeo player, we use this custom
// component to catch the error and ignore it if it occurs.

const ReactVimeo = props => {
  const isBrowser = useIsBrowser();

  // Only render the Vimeo player in the browser
  if (isBrowser) {
    // Ignore if there is an error loading the Vimeo player
    return (
      <ErrorBoundary fallback={null}>
        <ReactVimeoOriginal {...props} />
      </ErrorBoundary>
    );
  }

  return null;
};

export default ReactVimeo;
